import { Button, Checkbox } from '@integration/alexandria-ui';
import { TranslatorContainer, TranslatorLayout } from './TranslatorStyled';
import CloseIcon from '../Icons/CloseIcon';
import { useToolsBar } from './Translator.hooks';

const ToolsBar = ({ data }) => {
  const {
    close,
    handleChange,
    report,
    showPoTerms,
    shouldDisplayTranslator,
    shouldDisplayReportButton,
    shouldDisplayThisPage,
    t,
  } = useToolsBar(data);

  if (!shouldDisplayThisPage) {
    return null;
  }

  return (
    <TranslatorLayout>
      <TranslatorContainer>
        {shouldDisplayTranslator && (
          <Checkbox
            labelText={'translate'}
            onChange={handleChange}
            checked={!showPoTerms}
          />
        )}
        {shouldDisplayReportButton && (
          <Button
            onClick={report}
            size={'SMALL'}
            variant={'OUTLINED'}
            dataTestId={'report-button'}
          >
            {t('report_a_bug-button')}
          </Button>
        )}
        <CloseIcon onClick={close} theme={{ onPrimaryColor: 'blue' }} />
      </TranslatorContainer>
    </TranslatorLayout>
  );
};

export default ToolsBar;
